import { combineReducers } from '@reduxjs/toolkit'
import selectedPage from './selectedPage'

const page = combineReducers({
  selectedPage,
})

export type Page = ReturnType<typeof page>

export default page
